<template>
  <div class="sidebar-overlay" :class="{active: active}">
    <div class="sidebar-content">
      <div class="sidebar-header search-header">
        <vue-autosuggest class="autosuggest" v-model="query" :suggestions="filteredOptions"
                         @selected="onSelectedThenClose"
                         :limit="10"
                         :get-suggestion-value="getSuggestionValue"
                         :input-props="inputProps" component-attr-id-autosuggest="mobile-search">
          <template slot-scope="{suggestion}">
            <div>
                    <span v-if="suggestion.name === 'subject' || suggestion.name === 'chapter'">{{
                        suggestion.item.name
                      }}</span>
              <span v-else>{{ suggestion.item.title }}</span>
            </div>
          </template>
          <template slot="before-input">
            <i class="ti-arrow-left" @click="toggle"></i>
          </template>
          <template slot="after-input">
            <div class="loader" v-if="searching"></div>
            <i v-else class="ti-close" @click="onReset"></i>
          </template>
        </vue-autosuggest>
      </div>
      <div class="no-results" v-if="hasNoResults">
        <p class="text-center text-green">Aucun résultat disponible</p>
      </div>
    </div>
  </div>
</template>

<script>
import SearchMixin from "@/components/Mixins/SearchMixin";

export default {
  name: "SearchSidebar",
  mixins: [SearchMixin],
  data() {
    return {
      active: false
    }
  },
  methods: {
    toggle() {
      this.active = !this.active
    },
    onSelectedThenClose(option) {
      if (!option) return
      this.onSelected(option)
      this.reset()
      this.toggle()
    },
    onReset() {
      if (this.query === '') return this.toggle()
      this.reset()
    }
  }
}
</script>

<style lang="scss">
.sidebar-content .no-results {
  height: calc(100vh - 60px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-header {
  height: 60px;
  padding: 5px 15px;
  border-bottom: 1px solid $gray;
  display: flex;
  align-items: center;

  .loader::before {
    width: 20px;
    height: 20px;
    left: calc(50% - 10px);
    top: calc(50% - 10px);
  }

  .autosuggest {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include gap-items-x(5px);

    input {
      border: none;
      background-color: transparent !important;
    }

    > div {
      flex-grow: 1;
    }

    > i {
      cursor: pointer;
    }

    .autosuggest__results-container {
      top: 60px;
      left: 0;
      right: 0;
      margin: 0 !important;
      border: none;

      .autosuggest__results {
        border: none;
        max-height: calc(100vh - 60px);
      }
    }
  }
}
</style>
